import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ChiTieuThongKe {
  name: string;
  api_token: string;
}

export interface ChiTieuThongKeDetaiInfor {
  errors: unknown;
  ChiTieuThongKe: ChiTieuThongKe;
  isAuthenticated: boolean;
}

@Module
export default class ChiTieuThongKeDetail
  extends VuexModule
  implements ChiTieuThongKeDetaiInfor
{
  errors = {};
  ChiTieuThongKe = {} as ChiTieuThongKe;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get ChiTieuThongKeDetail() {
    return this.chiTieuThongKeDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.CHI_TIEU_THONG_KE_DETAIL_DATA](ChiTieuThongKe) {
    this.chiTieuThongKeDetailData = ChiTieuThongKe;
  }
  @Action
  [Actions.CHI_TIEU_THONG_KE_DETAIL](payload) {
    return ApiService.getDataDetail("/chitieu_tk", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.CHI_TIEU_THONG_KE_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
